namespace TabAurous.Production {
    export interface WorkOrderItemsRow {
        TransItemId?: number;
        TransId?: number;
        RefVoucherNo?: string;
        OrderTypeId?: number;
        TransDate?: string;
        VoucherNo?: string;
        UserId?: number;
        BagNo?: string;
        SubBagNo?: number;
        Parts?: number;
        Line_No?: number;
        DepartmentId?: number;
        POSCustomerId?: number;
        EmployeeId?: number;
        LedgerName?: string;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        ItemTypeId?: number;
        HasBom?: boolean;
        CalcOnId?: number;
        CalcUnitId?: number;
        StockAllocation?: boolean;
        AttributeId?: number;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondWeight?: number;
        DiamondPieces?: number;
        StoneWeight?: number;
        StonePieces?: number;
        OtherWeight?: number;
        OtherPieces?: number;
        Purity?: number;
        PureWeight?: number;
        DeliveryDate?: string;
        BOMDetails?: WorkOrderBOMRow[];
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        HSN?: string;
        TaxCode?: string;
        ProductTypeId?: number;
        ProductTypeName?: string;
        Attribute?: string;
        ItemType?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        ProductSizeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Remarks?: string;
    }

    export namespace WorkOrderItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.WorkOrderItems';
        export const lookupKey = 'Production.WorkOrderItems';

        export function getLookup(): Q.Lookup<WorkOrderItemsRow> {
            return Q.getLookup<WorkOrderItemsRow>('Production.WorkOrderItems');
        }
        export const deletePermission = 'Production:WorkOrder:Delete';
        export const insertPermission = 'Production:WorkOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:WorkOrder:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            RefVoucherNo = "RefVoucherNo",
            OrderTypeId = "OrderTypeId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            Parts = "Parts",
            Line_No = "Line_No",
            DepartmentId = "DepartmentId",
            POSCustomerId = "POSCustomerId",
            EmployeeId = "EmployeeId",
            LedgerName = "LedgerName",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ItemTypeId = "ItemTypeId",
            HasBom = "HasBom",
            CalcOnId = "CalcOnId",
            CalcUnitId = "CalcUnitId",
            StockAllocation = "StockAllocation",
            AttributeId = "AttributeId",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondWeight = "DiamondWeight",
            DiamondPieces = "DiamondPieces",
            StoneWeight = "StoneWeight",
            StonePieces = "StonePieces",
            OtherWeight = "OtherWeight",
            OtherPieces = "OtherPieces",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeliveryDate = "DeliveryDate",
            BOMDetails = "BOMDetails",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            HSN = "HSN",
            TaxCode = "TaxCode",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            Attribute = "Attribute",
            ItemType = "ItemType",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            ProductSizeId = "ProductSizeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Remarks = "Remarks"
        }
    }
}
